import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import { Phases_getInstance153dg9ipormlv as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { isSuspendFunction153vlp5l2npj9 as isSuspendFunction } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  cancel1xim2hrvjmwpn as cancel,
  Key_instance17dpgmdbeabno as Key_instance,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPlugin16sdkdabbewya as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  return LOGGER;
}
var LOGGER;
function get_HttpRequestLifecycle() {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  return HttpRequestLifecycle;
}
var HttpRequestLifecycle;
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.u5q_1.p4q($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$intercept, it, $completion) {
  var tmp = $this.v5q_1($this$intercept.m4r_1, PipelineContext$proceed$ref_0($this$intercept), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var PipelineContext$proceed$refClass;
function PipelineContext$proceed$ref() {
  if (PipelineContext$proceed$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.u5q_1 = p0;
      }
      td($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    PipelineContext$proceed$refClass = $;
  }
  return PipelineContext$proceed$refClass;
}
function PipelineContext$proceed$ref_0(p0) {
  var i = new (PipelineContext$proceed$ref())(p0);
  var l = ($completion) => i.td($completion);
  l.$arity = 0;
  return l;
}
var SetupRequestContext$install$slambdaClass;
function SetupRequestContext$install$slambda() {
  if (SetupRequestContext$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.v5q_1 = $handler;
      }
      x5g($this$intercept, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$intercept, it), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.x5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    SetupRequestContext$install$slambdaClass = $;
  }
  return SetupRequestContext$install$slambdaClass;
}
function SetupRequestContext$install$slambda_0($handler) {
  var i = new (SetupRequestContext$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.x5g($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var SetupRequestContextClass;
function SetupRequestContext() {
  if (SetupRequestContextClass === VOID) {
    class $ {
      w5q(client, handler) {
        var tmp = Phases_getInstance().l5m_1;
        client.a5g_1.q4r(tmp, SetupRequestContext$install$slambda_0(handler));
      }
      q5m(client, handler) {
        return this.w5q(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SetupRequestContext');
    SetupRequestContextClass = $;
  }
  return SetupRequestContextClass;
}
var SetupRequestContext_instance;
function SetupRequestContext_getInstance() {
  return SetupRequestContext_instance;
}
function attachToClientEngineJob(requestJob, clientEngineJob) {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  var handler = clientEngineJob.hx((cause) => {
    if (!(cause == null)) {
      get_LOGGER().q4s('Cancelling request because engine Job failed with error: ' + cause.toString());
      cancel(requestJob, 'Engine failed', cause);
    } else {
      get_LOGGER().q4s('Cancelling request because engine Job completed');
      requestJob.w12();
    }
    return Unit_instance;
  });
  requestJob.hx((it) => {
    handler.vz();
    return Unit_instance;
  });
}
function HttpRequestLifecycle$lambda($this$createClientPlugin) {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  var tmp = SetupRequestContext_instance;
  $this$createClientPlugin.c5n(tmp, HttpRequestLifecycle$lambda$slambda_0($this$createClientPlugin));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, request, proceed, $completion) {
  var executionContext = SupervisorJob(request.v5g_1);
  attachToClientEngineJob(executionContext, ensureNotNull($this.x5q_1.y5m_1.z5f_1.hd(Key_instance)));
  try {
    request.v5g_1 = executionContext;
    var tmp = proceed($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var cause = $p;
      executionContext.v12(cause);
      throw cause;
    } else {
      throw $p;
    }
  }
  finally {
    executionContext.w12();
  }
  return Unit_instance;
}
var HttpRequestLifecycle$lambda$slambdaClass;
function HttpRequestLifecycle$lambda$slambda() {
  if (HttpRequestLifecycle$lambda$slambdaClass === VOID) {
    class $ {
      constructor($this_createClientPlugin) {
        this.x5q_1 = $this_createClientPlugin;
      }
      y5q(request, proceed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, request, proceed), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof HttpRequestBuilder() ? p1 : THROW_CCE();
        return this.y5q(tmp, (!(p2 == null) ? isSuspendFunction(p2, 0) : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpRequestLifecycle$lambda$slambdaClass = $;
  }
  return HttpRequestLifecycle$lambda$slambdaClass;
}
function HttpRequestLifecycle$lambda$slambda_0($this_createClientPlugin) {
  var i = new (HttpRequestLifecycle$lambda$slambda())($this_createClientPlugin);
  var l = (request, proceed, $completion) => i.y5q(request, proceed, $completion);
  l.$arity = 2;
  return l;
}
var properties_initialized_HttpRequestLifecycle_kt_3hmcrf;
function _init_properties_HttpRequestLifecycle_kt__jgkmfx() {
  if (!properties_initialized_HttpRequestLifecycle_kt_3hmcrf) {
    properties_initialized_HttpRequestLifecycle_kt_3hmcrf = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestLifecycle');
    HttpRequestLifecycle = createClientPlugin('RequestLifecycle', HttpRequestLifecycle$lambda);
  }
}
//region block: init
SetupRequestContext_instance = new (SetupRequestContext())();
//endregion
//region block: exports
export {
  get_HttpRequestLifecycle as get_HttpRequestLifecycle1e7j0z243lnj5,
};
//endregion

//# sourceMappingURL=HttpRequestLifecycle.mjs.map
